import { SurveyAnswer } from './survey-answer';

export class SurveyResponse{
    surveyAnswers: SurveyAnswer[];
    surveyId: number;
    surveySharedId: number;
}